module.exports = __webpack_public_path__ + "images/kit-image.e682613786825d2d61c17cabc5db160f.png";